import { useState } from 'react';

export const useExamFeedbackHook = () => {
  const [isOpenPrint, setIsOpenPrint] = useState<boolean>(false);
  const [isOpenAnswerCard, setIsOpenAnswerCard] = useState<boolean>(false);

  return {
    isOpenPrint,
    isOpenAnswerCard,
    setIsOpenPrint,
    setIsOpenAnswerCard,
  };
};
